import apiClient from '../utilities/apiClient.utility';

const userUrl = `${window.config.CONNECT_URLS.users}`;

export const createAppointment = async (program_id: string, payload) => {
  return await apiClient.post(
    `${userUrl}/${program_id}/dashboard/appointment`, 
    payload
  );
}

export const updateAppointment = async (program_id: string, payload) => {
  const { appointment_id } = payload
  return await apiClient.patch(
    `${userUrl}/${program_id}/dashboard/appointment/${appointment_id}`,
    payload
  );
}